import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../../store/store-controller/store.js'
import eventBus from '@/assets/js/event/EventBus.js';
import router from '@/router'
import * as BackendSetting from "@/assets/js/util/BackendSetting.js"
import {cm_navbar_dynamic_dropdown_container_position} from '@/assets/js/cm-navbar.js'

Vue.use(VueI18n)

// 語言包
const langs = {};

// 將lang資料夾下符合條件的*.json檔讀入langs陣列中，key=/*.json，value=json檔中的內容
const languagePack = require.context('../lang', true, /[A-Za-z0-9-_,\s]+\.json$/i)
languagePack.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
        const locale = matched[1]
        store.dispatch('storeI18n/actionAddLanguages', locale);
        langs[locale] = languagePack(key)
    }
})



// i18n基本設置
export const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE, // set locale
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    messages: langs, // set locale messages
})


function setI18nLanguage(clientLanguage) {
    i18n.locale = clientLanguage;
    store.dispatch('storeI18n/actionSetNowLanguage', clientLanguage);
    if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
        //safari在無痕模式下，無法直接使用localStorage
        try {
            localStorage.setItem('cm_language', clientLanguage);
        }
        catch (error) {
            console.log('使用localStorage時出錯: ' + error.message)
            // document.cookie = 'language=' + language;
        }
    }
    document.querySelector('html').setAttribute('lang', clientLanguage);
}


// 切換語系，附lazy-loading功能
export function loadLanguageAsync(clientLanguage) {
    const loadedLanguages = store.getters['storeI18n/getLanguages']; // 取得目前讀入的所有語言包
    if (i18n.locale !== clientLanguage) {
        if (!loadedLanguages.includes(clientLanguage)) { // 沒有語言包，進行加載
            return import( /* webpackChunkName: "lang-[request]" */ `../lang/${clientLanguage}.json`)
                .then(msgs => {
                    i18n.setLocaleMessage(clientLanguage, msgs.default)
                    store.dispatch('storeI18n/actionAddLanguages', clientLanguage);
                    i18n.locale = clientLanguage;
                    setI18nLanguage(clientLanguage)
                }).catch(() => {
                    clientLanguage = process.env.VUE_APP_I18N_LOCALE;
                    i18n.locale = clientLanguage;
                    setI18nLanguage(clientLanguage)
                })
        }
        i18n.locale = clientLanguage;
    }
    setI18nLanguage(clientLanguage)
    return Promise.resolve(true)
}


export function routerSetLanguage(clientLanguage, enforceChangeLanguage) {
    if(enforceChangeLanguage!=undefined && enforceChangeLanguage!="") { // 強制設置語系
        loadLanguageAsync(enforceChangeLanguage).then(function() {
            whenChangeLanguage(i18n, true)
        })
    }
    else if (store.getters['storeI18n/isFirstSet'] == true) { // 第一次進入網站時設置語系
        let setLanguage = clientLanguage;
        if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
            if (localStorage.getItem("cm_language") != null) {
                setLanguage = localStorage.getItem('cm_language')
            }
        }

        store.dispatch('storeI18n/actionIsFirstSet', false);
        loadLanguageAsync(setLanguage);
    }
    return Promise.resolve(true);
}


/**
 * 更換語系時，client所停留的頁面資訊必須再次更新
 * @param {*} i18nObj 
 * @param {*} isEnforceChange 頁面資訊是否依照語系進行強制更新
 */
export async function whenChangeLanguage(i18nObj=false, isEnforceChange=false) {
    cm_navbar_dynamic_dropdown_container_position();

    // 強制設置
    if(isEnforceChange == true) {
        // 清空所有從後台取得並記錄在store的設定
        await BackendSetting.cleanAllBackendSetting();
    }

    // Update Header
    eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_CHANGE_HEADER)

    // 首頁
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_HOME) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_HOME, i18nObj)
    }

    // 遊戲
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_GAME) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_GAME, i18nObj)
    }

    // 新聞
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_NEWS) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_NEWS, i18nObj)
    }
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_NEWS) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_NEWS_CONTENT, i18nObj)
    }

    // 儲值中心 > 儲值(中文版)
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_DEPOSIT) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DEPOSIT, i18nObj)
    }

    // 儲值中心 > 儲值(英文版)
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_TOPUP) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_TOPUP, i18nObj)
    }

    // 儲值中心 > Codapay
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_CODAPAY) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CODAPAY, i18nObj)
    }

    // 儲值中心 > 紀錄查詢
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DEPOSIT_HISTORY_LIST, i18nObj)
    }
    
    // 儲值中心 > 電子發票
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_INVOICE) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_INVOICE, i18nObj)
    }

    // 儲值中心 > 序號
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_GIFTCODE) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_GIFTCODE, i18nObj)
    }

    // 客服中心 > 常見問題
    if (router.currentRoute.name == process.env.VUE_APP_ROUTER_FAQ){
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_FAQ , i18nObj)
    }

    // 客服中心 > 問題回報
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_CONTACT_US) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CONTACT_US, i18nObj)
    }

    // 客服中心 > 紀錄查詢
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_HISTORY_LIST) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_HISTORY_LIST, i18nObj)
    }

    // 客服中心 > 文件下載
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_DOWNLOAD) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DOWNLOAD, i18nObj)
    }
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_DOWNLOAD) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DOWNLOAD_CONTENT, i18nObj)
    }

    // Footer > 聯絡我們
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_COOPERATION_PROPOSAL) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_COOPERATION_PROPOSAL, i18nObj)
    }

    // Footer > 關於我們
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_INTRO) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_INTRO, i18nObj)
    }

    // Footer > 隱私協議
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_PRIVACY_POLICY) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_PRIVACY_POLICY, i18nObj)
    }

    // Footer > 服務條款
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_TERMS_OF_SERVICE) {
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_TERMS_OF_SERVICE, i18nObj)
    }
}